import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import BestPredictionSite from "@/pages/BestPredictionSite";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/best-football-prediction-site")({
  head: () => ({
    meta: [
      { title: "Best Football Prediction Site: AI Soccer Tips | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["footballPredictions", "aiPredictions"] }).meta },
      { name: "description", content: "Looking for the best football prediction site? Statlign delivers accurate, AI-backed soccer predictions with confidence scores, transparent reasoning and an honest track record." },
      { property: "og:title", content: "Best Football Prediction Site: AI Soccer Tips | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Looking for the best football prediction site? Statlign delivers accurate, AI-backed soccer predictions with confidence scores, transparent reasoning and an honest track record." },
      { name: "twitter:title", content: "Best Football Prediction Site: AI Soccer Tips | Statlign" },
      { name: "twitter:description", content: "Looking for the best football prediction site? Statlign delivers accurate, AI-backed soccer predictions with confidence scores, transparent reasoning and an honest track record." },
    ],
  }),
  component: () => (
    <MainLayout>
      <BestPredictionSite />
    </MainLayout>
  ),
});
